var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"coming-soon"},[_vm._v(_vm._s(_vm.$t('coming.soon')))])
}
var staticRenderFns = []

export { render, staticRenderFns }